import styled from 'styled-components';

export const StyledWrapper = styled.div`
  display: flex;
`;

export const StyledText = styled.span`
  white-space: nowrap;
  margin-right: 3px;
`;

export const StyledBookingSeat = styled.span`
  cursor: pointer;
  background-color: #e3e3e3;
  border-radius: 20px;
  margin-right: 2px;
  padding: 0 8px;
  width: 80px;

  &:hover {
    & a {
      text-decoration: underline;
    }
  }

  & a {
    color: #00286a;
    text-decoration: none;
  }
`;

export const StyledSeatsContent = styled.div`
  margin-bottom: 8px;
`;
